/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Insolvency_HintInputs */

const cs_property_registry_insolvency_hint = /** @type {(inputs: Property_Registry_Insolvency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oficiální kontrola ISIR (MSp). Preferujte IČO výše, nebo jméno + datum narození u fyzické osoby.`)
};

const en_property_registry_insolvency_hint = /** @type {(inputs: Property_Registry_Insolvency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official MoJ ISIR check. Prefer IČO above, or name + date of birth for a person.`)
};

/**
* | output |
* | --- |
* | "Official MoJ ISIR check. Prefer IČO above, or name + date of birth for a person." |
*
* @param {Property_Registry_Insolvency_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_insolvency_hint = /** @type {((inputs?: Property_Registry_Insolvency_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Insolvency_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_insolvency_hint(inputs)
	return cs_property_registry_insolvency_hint(inputs)
});